import { gql } from '@apollo/client';

export const GET_MERCHANT_REVENUE = gql`
  query activities($merchant_id: String!) {
    activities_aggregate(
      where: {
        actor_id: { _eq: $merchant_id }
        type: { _eq: "merchant_revenue" }
      }
    ) {
      aggregate {
        sum {
          amount
          fiat_amount
        }
      }
    }
    merchants(where: { user_id: { _eq: $merchant_id } }) {
      id
      business_name
    }
    promotions(where: { user_id: { _eq: $merchant_id } }) {
      id
      product {
        id
        title
        description
        price
        media_url
      }
      purchases_aggregate (
        where: {
          paid: { _eq: true }
        }
      ) {
        aggregate {
          count
          sum {
            amount
            sats_amount
            cashback
          }
        }
      }
    }
  }
`;

export const GET_USER = gql`
  query users_by_pk($id: String!) {
    users_by_pk(id: $id) {
      id
      name
      phone
      email
      bio
      city
      state
      country
      avatar
      username
      btc_beach_username
      role
      merchant { 
        id
        address
        business_name
        background_url
        logo_url
        description
        phone_number
        email
        country
        currency
        user_id
        website
        oshi_scanner_keys {
          id
          merchant_id
          user_id
          created_at
        }
      }
      provider_keys {
        id
        provider_name
        account_id
        key_name
        key_value
        customer_name
        customer_email
        created_at
        updated_at
      }
      balance {
        user_id
        reward
        balance
        cashback
      }
      referrals {
        id
        used_date
      }
    }
  }
`;

export const GET_USERS_BY_USER_NAME = gql`
  query users($query: String!) {
    users(where: { username: { _like: $query } }) {
      id
      name
      phone
      email
      bio
      city
      state
      country
      avatar
      username
      employees {
        id
        user_id
        employee_name
        active
        merchant_id
      }
      referrals {
        id
        used_date
      }
    }
  }
`;

export const GET_EVANGELIST_ACTIVITY = gql`
  query evangelist_activity($actorid: String!, $cursor: timestamptz!, $limit: Int!) {
    activities(
      limit: $limit,
      where: { 
        actor_id: { _eq: $actorid } 
        type: { _eq: "evangelist_reward" }
        amount: { _gt: 0 }
        created_at: { _lt: $cursor }
      }
      order_by: { created_at: desc }
    ) {
      id
      amount
      fiat_amount
      type
      created_at
      purchase {
        merchant {
          id
          business_name
          logo_url
        }
      }
    }
  }
`;

export const GET_ACTIVITIES = gql`
  query activites($actorid: String!, $cursor: timestamptz!, $limit: Int!) {
    activities(
      limit: $limit,
      where: { 
        actor_id: { _eq: $actorid } 
        type: { _neq: "evangelist_reward" }
        amount: { _gt: 0 }
        created_at: { _lt: $cursor }
      }
      order_by: { created_at: desc }
    ) {
      id
      amount
      fiat_amount
      type
      created_at
      promotion {
        id
        product {
          id
          title
          description
          media_url
        }
      }
      purchase {
        id
        use_date
        merchant {
          id
          business_name
          logo_url
        }
        promotion {
          id
          product {
            title
            description
            media_url
          }
        }
        product {
          id
          title
          description
          media_url
        }
        user {
          id
          avatar
          name
        }
      }
    }
  }
`;

export const NEARBY_MERCHANTS = gql`
  query search_merchants_near_user($userid: String!, $distance: Int!) {
    search_merchants_near_user(
      args: { userid: $userid, distance_kms: $distance }
    ) {
      nearby_merchants
    }
  }
`;

export const NEARBY_VENDORS = gql`
  query search_vendors_near_user($userid: String!, $distance: Int!) {
    search_vendors_near_user(
      args: { userid: $userid, distance_kms: $distance }
    ) {
      nearby_merchants
    }
  }
`;

export const PURCHASE_RECEIVED_SATS = gql`
  query purchases_aggregate($userid: String!) {
    purchases_aggregate(where: { merchant_id: { _eq: $userid } }) {
      aggregate {
        sum {
          sats_amount
        }
      }
    }
  }
`;

export const PURCHASE_PAID_SATS = gql`
  query purchases_aggregate($userid: String!) {
    purchases_aggregate(where: { user_id: { _eq: $userid } }) {
      aggregate {
        sum {
          sats_amount
        }
      }
    }
  }
`;

export const GET_BALANCES = gql`
  query balances_by_pk($userid: String!) {
    balances_by_pk(user_id: $userid) {
      balance
      reward
      cashback
    }
  }
`;

export const GET_PURCHASE = gql`
  query purchases($promotion_id: uuid!) {
    purchases(where: { promotion_id: { _eq: $promotion_id } }) {
      id
      invoice_id
      paid
      amount
    }
  }
`;

export const GET_PURCHASE_BY_REFERRAL_CODE = gql`
  query purchases($code: uuid!) {
    purchases(
      where: { referral_code: { _eq: $code }, paid: { _eq: true } }
      order_by: { created_at: desc }
    ) {
      id
      invoice_id
      paid
      amount
      created_at
      cashback
      sats_amount
      referral_code
      used_referral_code
      order_id
      used_date
    }
  }
`;

export const GET_ACTIVE_PURCHASES_BY_USER_ID = gql`
  query purchases($user_id: String!, $cursor: timestamptz!, $limit: Int!) {
    purchases(
      limit: $limit,
      where: {
        user_id: { _eq: $user_id }
        paid: { _eq: true }
        used_date: { _is_null: true }
        order_id: { _is_null: false }
        created_at: { _lt: $cursor }
      }
      order_by: { created_at: desc }
    ) {
      id
      promotion {
        id
        discount_percentage
        special_instructions
        product {
          id
          title
          description
          price
          media_url
        }
      }
      product {
        id
        title
        description
        price
        media_url
      }
      merchant {
        id
        business_name
        logo_url
      }
      order {
        id
        quantity
        amount
        fiat_value
        gift_cards {
          id
          gan
          amount
        }
      }
      invoice_id
      paid
      amount
      created_at
      cashback
      sats_amount
      referral_code
      used_referral_code
      order_id
      used_date
      promo_code
      description
    }
  }
`;

export const GET_PURCHASES_BY_USER_ID = gql`
  query purchases($user_id: String!, $cursor: timestamptz!, $limit: Int!) {
    purchases(
      limit: $limit,
      where: { user_id: { _eq: $user_id }, paid: { _eq: true }, created_at: { _lt: $cursor } }
      order_by: { created_at: desc }
    ) {
      id
      promotion {
        id
        discount_percentage
        special_instructions
        product {
          id
          title
          description
          price
          media_url
        }
      }
      product {
        id
        title
        description
        price
        media_url
      }
      merchant {
        id
        business_name
        logo_url
      }
      order {
        id
        quantity
        amount
        fiat_value
        gift_cards {
          id
          gan
          amount
        }
      }
      invoice_id
      paid
      amount
      created_at
      cashback
      sats_amount
      referral_code
      used_referral_code
      order_id
      used_date
      promo_code
      description
    }
  }
`;

export const GET_PURCHASE_BY_PK = gql`
  query purchases_by_pk($id: uuid!) {
    purchases_by_pk(id: $id) {
      id
      promotion {
        id
        discount_percentage
        special_instructions
        product {
          id
          title
          description
          price
          user_id
          media_url
          addons {
            product_id
            addon_id
            addon {
              id
              title
              price
            }
          }
        }
      }
      product {
        id
        title
        description
        price
        user_id
        media_url
        addons {
          product_id
          addon_id
          addon {
            id
            title
            price
          }
        }
      }
      order {
        id
        quantity
        amount
        fiat_value
        gift_cards {
          id
          gan
          amount
        }
      }
      invoice_id
      paid
      amount
      created_at
      cashback
      sats_amount
      promo_code
      description
      merchant_id
    }
  }
`;

export const GET_PRODUCT_BY_PK = gql`
  query products_by_pk($id: uuid!) {
    products_by_pk(id: $id) {
      id
      user_id
      title
      description
      price
      media_url
      active
      limit_quantity
      category_id
      merchant {
        id
        business_name
      }
      addons {
        product_id
        addon_id
        addon {
          id
          title
          price
        }
      }
    }
  }
`;

export const GET_PROMOTION_BY_PK_OWNER = gql`
  query promotions_by_pk($id: uuid!) {
    promotions_by_pk(id: $id) {
      id
      active
      created_at
      discount_percentage
      referral_percentage
      giveaway_percentage
      giveaway_purchases_count
      number_of_promos
      promo_period
      start_date
      end_date
      product_id
      user_id
      limit_quantity
      codes
      discount_codes {
        id
        user_id
        promotion_id
        product_id
        codes
      }
      special_instructions
      product {
        id
        title
        description
        price
        media_url
        addons {
          product_id
          addon_id
          addon {
            id
            title
            price
          }
        }
      }
      merchant {
        id
        user_id
        address
        business_name
        background_url
        logo_url
        description
        phone_number
        location
        open
        close
        wait_time
        email
        referral {
          user_id
          user {
            id
            balance {
              reward
              cashback
              balance
            }
          }
        }
      }
    }
  }
`;

export const GET_PROMOTION_BY_PK = gql`
  query promotions_by_pk($id: uuid!) {
    promotions_by_pk(id: $id) {
      id
      active
      created_at
      discount_percentage
      referral_percentage
      giveaway_percentage
      giveaway_purchases_count
      number_of_promos
      promo_period
      start_date
      end_date
      product_id
      user_id
      limit_quantity
      special_instructions
      product {
        id
        title
        description
        price
        media_url
        merchant {
          id
          business_name
        }
        addons {
          product_id
          addon_id
          addon {
            id
            title
            price
          }
        }
      }
      merchant {
        id
        user_id
        address
        business_name
        background_url
        logo_url
        description
        phone_number
        location
        open
        close
        wait_time
        email
        referral {
          user_id
          user {
            id
            balance {
              reward
              cashback
              balance
            }
          }
        }
      }
    }
  }
`;

// TODO: improve logic for featured promotions
export const GET_FEED_PROMOTIONS = gql`
  query promotions {
    featured: promotions(
      where: {
        active: { _eq: true }
        deleted_at: { _is_null: true }
        featured: { _eq: true }
      }
      order_by: { created_at: desc }
    ) {
      id
      active
      discount_percentage
      giveaway_percentage
      giveaway_purchases_count
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
    popular: promotions(
      order_by: { purchases_aggregate: { count: desc } }
      where: { active: { _eq: true }, deleted_at: { _is_null: true } }
    ) {
      id
      active
      discount_percentage
      referral_percentage
      giveaway_percentage
      giveaway_purchases_count
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
    recent: promotions(
      where: { active: { _eq: true }, deleted_at: { _is_null: true } }
      order_by: { created_at: desc }
    ) {
      id
      active
      discount_percentage
      referral_percentage
      giveaway_percentage
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const GET_PROMOTIONS = gql`
  query promotions {
    promotions(
      where: { active: { _eq: true }, deleted_at: { _is_null: true } }
      order_by: { created_at: desc }
    ) {
      id
      active
      discount_percentage
      referral_percentage
      giveaway_percentage
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const GET_POPULAR_PROMOTIONS = gql`
  query promotions {
    promotions(
      order_by: { purchases_aggregate: { count: desc } }
      where: { active: { _eq: true }, deleted_at: { _is_null: true } }
    ) {
      id
      active
      discount_percentage
      referral_percentage
      giveaway_percentage
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

// TODO: improve logic for this
export const GET_FEATURED_PROMOTIONS = gql`
  query promotions {
    promotions(
      where: {
        active: { _eq: true }
        deleted_at: { _is_null: true }
        discount_percentage: { _gt: 0.25 }
      }
      order_by: { created_at: desc }
    ) {
      id
      active
      discount_percentage
      referral_percentage
      giveaway_percentage
      limit_quantity
      number_of_promos
      created_at
      user_id
      product_id
      start_date
      end_date
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const GET_REFERRALS = gql`
  query referrals($userid: String!) {
    referrals(
      where: { user_id: { _eq: $userid }, active: { _eq: true } }
      order_by: { created_at: desc }
    ) {
      used_date
      created_at
      invite_date
      merchant_name
      merchant_address
      merchant_phone
      code
      active
      id
    }
  }
`;

export const GET_SERVICES = gql`
  query services($user_id: String!) {
    services(where: { user_id: { _eq: $user_id } }) {
      id
      service_name
      price
    }
  }
`;

export const GET_WAITROOM = gql`
  query waitrooms($merchant_id: uuid!) {
    waitrooms(
      where: { merchant_id: { _eq: $merchant_id }, active: { _eq: true } }
    ) {
      id
      start_time
      end_time
      merchant {
        id
        business_name
      }
      user {
        name
      }
    }
  }
`;

export const GET_MERCHANT_BY_PK = gql`
  query merchants_by_pk($id: uuid!) {
    merchants_by_pk(id: $id) {
      id
      user_id
      address
      business_name
      background_url
      logo_url
      description
      phone_number
      location
      open
      close
      wait_time
      email
      global_discount
      bitcoin_meetups (
        where: { approved: { _eq: true }, datetime: { _gt: "now()" } }
        order_by: { datetime: asc }
      ) {
        id
        datetime
        title
        description
      }
      followers_aggregate {
        aggregate {
          count
        }
      }
      promotions_aggregate(where: { active: { _eq: true }, deleted_at: { _is_null: true } }) {
        aggregate {
          count
          max {
            discount_percentage
          }
        }
      }
      promotions(
        where: { active: { _eq: true }, deleted_at: { _is_null: true } }
        order_by: { created_at: asc }
      ) {
        id
        discount_percentage
        giveaway_percentage
        giveaway_purchases_count
        giveaway_pool_count
        referral_percentage
        active
        product_id
        product {
          id
          title
          description
          price
          media_url
          addons {
            product_id
            addon_id
            addon {
              id
              title
              price
            }
          }
        }
        limit_quantity
      }
      products(
        where: { active: { _eq: true }, deleted_at: { _is_null: true } }
        order_by: { created_at: asc }
      ) {
        id
        active
        title
        description
        media_url
        price
        limit_quantity
        category {
          id
          name
        }
        promotions(where: { deleted_at: { _is_null: false } }) {
          id
          discount_percentage
          giveaway_percentage
          giveaway_purchases_count
          giveaway_pool_count
          referral_percentage
          active
          product_id
          product {
            id
            title
            description
            price
            media_url
            addons {
              product_id
              addon_id
              addon {
                id
                title
                price
              }
            }
          }
          limit_quantity
        }
      }
    }
  }
`;

export const GET_MERCHANT_KEYS = gql`
query merchants($user_id: String!) {
  merchants(where: { user_id: { _eq: $user_id } }) {
    id
    business_name
    address
    phone_number
    email
    opennode_account_id
    opennode_key_public
    provider_key
    kyc_status
    block_tokens {
      id
      expires_at
    }
    provider_keys(order_by: {provider_name:asc}) {
      id
      provider_name
      account_id
      key_name
      key_value
      customer_name
      customer_email
      created_at
      updated_at
      default
    }
  }
}`;

export const GET_MERCHANT_PROFILE = gql`
query merchants($user_id: String!) {
  merchants(where: { user_id: { _eq: $user_id } }) {
    id
    address
    business_name
    background_url
    logo_url
    description
    phone_number
    email
    country
    currency
  }
}`;

export const GET_MERCHANTS = gql`
query merchants {
  merchants(where: { active: { _eq: true }, approved: { _eq: true } }) {
    id
    address
    business_name
    background_url
    logo_url
    description
    phone_number
    email
    location
    user_id
    category {
      id
      name
      icon
    }
    bitcoin_meetups(
      where: { approved: { _eq: true }, datetime: { _gt: "now()" } }
    ){
      id
      datetime
      title
      description
    }
  }
}`;

export const GET_LOCATIONS = gql`
query locations {
  locations(where: { active: { _eq: true } }, order_by: { city: desc }) {
    id
    city
    state
    country
    name
    media_url
    location
  }
}`;

export const GET_MERCHANT = gql`
  query merchants($user_id: String!) {
    merchants(where: { user_id: { _eq: $user_id } }) {
      id
      user_id
      address
      business_name
      background_url
      logo_url
      description
      phone_number
      location
      open
      opennode_key_public
      provider_key
      close
      wait_time
      email
      addons(where: { deleted_at: { _is_null: true } }) {
        id
        title
        price
      }
      purchases(order_by: { updated_at: desc }) {
        id
        invoice_id
        use_date
        timestamp
        promotion {
          id
          product {
            id
            title
          }
        }
        product {
          id
          title
        }
        amount
        user {
          id
          avatar
          email
          username
        }
      }
      promotions(
        where: { deleted_at: { _is_null: true } }
        order_by: { created_at: asc }
      ) {
        id
        discount_percentage
        giveaway_percentage
        giveaway_purchases_count
        giveaway_pool_count
        referral_percentage
        active
        product_id
        product {
          id
          title
          description
          price
          media_url
          addons {
            product_id
            addon_id
            addon {
              id
              title
              price
            }
          }
        }
        limit_quantity
      }
      products(
        where: { deleted_at: { _is_null: true } }
        order_by: { created_at: asc }
      ) {
        id
        active
        title
        description
        media_url
        price
        limit_quantity
        promotions(where: { deleted_at: { _is_null: false } }) {
          id
          discount_percentage
          giveaway_percentage
          giveaway_purchases_count
          giveaway_pool_count
          referral_percentage
          active
          product_id
          product {
            id
            title
            description
            price
            media_url
            addons {
              product_id
              addon_id
              addon {
                id
                title
                price
              }
            }
          }
          limit_quantity
        }
      }
      posts {
        id
        caption
        url
        created_at
      }
      services {
        service_name
        price
      }
      referral {
        user {
          balance {
            balance
            reward
            cashback
          }
        }
        user_id
      }
      waitrooms_aggregate(where: { active: { _eq: true } }) {
        aggregate {
          count
        }
      }
    }
  }
`;

export const GET_PROMOTIONS_BY_MERCHANT_ID = gql`
  query($id: String!) {
    promotions(
      where: {
        user_id: { _eq: $id }
        active: { _eq: true }
        deleted_at: { _is_null: true }
      }
    ) {
      id
      active
      discount_percentage
      created_at
      user_id
      product_id
      product {
        id
        title
        description
        price
        media_url
        active
        category_id
        limit_quantity
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const USER_INFO = gql`
  query($id: String!) {
    users(where: { id: { _eq: $id } }) {
      email
      avatar
      last_seen
      name
      username
      promotions_aggregate(
        where: { active: { _eq: true }, deleted_at: { _is_null: true } }
      ) {
        aggregate {
          count
        }
      }
      merchant {
        followers_aggregate {
          aggregate {
            count
          }
        }
      }
      products_aggregate(where: { active: { _eq: true } }) {
        aggregate {
          count
        }
      }
    }
    posts(where: { user_id: { _eq: $id } }) {
      url
      caption
      id
    }
    promotions(
      where: {
        user_id: { _eq: $id }
        active: { _eq: true }
        deleted_at: { _is_null: true }
      }
    ) {
      id
      active
      discount_percentage
      created_at
      user_id
      product_id
      limit_quantity
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
    trending_promotions: promotions(
      order_by: { purchases_aggregate: { count: desc } }
      where: {
        active: { _eq: true }
        deleted_at: { _is_null: true }
        user_id: { _eq: $id }
      }
    ) {
      id
      active
      discount_percentage
      created_at
      limit_quantity
      user_id
      product_id
      product {
        id
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
    products(
      where: {
        user_id: { _eq: $id }
        active: { _eq: true }
        deleted_at: { _is_null: true }
      }
      order_by: { created_at: desc }
    ) {
      id
      media_url
      price
      description
      title
      limit_quantity
      user_id
      category {
        id
        name
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
          location
        }
      }
      promotions(
        where: { active: { _eq: true }, deleted_at: { _is_null: true } }
      ) {
        id
        active
        discount_percentage
        created_at
        user_id
        product_id
        product {
          id
          title
          description
          price
          media_url
        }
      }
    }
  }
`;

export const NUMBER_OF_FOLLOWING = gql`
  query($id: String!) {
    follows_aggregate(where: { follower_id: { _eq: $id } }) {
      aggregate {
        count
      }
    }
  }
`;

export const NUMBER_OF_FOLLOWERS = gql`
  query($id: String!) {
    follows_aggregate(where: { following_id: { _eq: $id } }) {
      aggregate {
        count
      }
    }
  }
`;

export const FETCH_FOLLOWERS = gql`
  query($followingId: String!, $userId: String!) {
    follows(
      where: {
        follower_id: { _eq: $userId }
        following_id: { _eq: $followingId }
      }
    ) {
      id
      notify
    }
  }
`;

export const FETCH_LIKES = gql`
  query($id: uuid!, $userId: String!) {
    posts(where: { id: { _eq: $id } }) {
      likes_aggregate {
        aggregate {
          count
        }
      }
      likes(where: { user_id: { _eq: $userId } }) {
        id
      }
    }
  }
`;

export const FETCH_LIKE = gql`
  query($promotion_id: uuid, $product_id: uuid, $user_id: String!) {
    likes(
      where: {
        user_id: { _eq: $user_id }
        promotion_id: { _eq: $promotion_id }
        product_id: { _eq: $product_id }
      }
    ) {
      id
      promotion_id
      user_id
    }
  }
`;

export const GET_LIKES = gql`
  query($user_id: String!) {
    promotions: likes(
      where: { user_id: { _eq: $user_id }, promotion_id: { _is_null: false }, promotion: { active: { _eq: true }, deleted_at: {_is_null: true} } }
      order_by: { created_at: desc }
    ) {
      id
      promotion {
        id
        active
        discount_percentage
        created_at
        user_id
        product_id
        limit_quantity
        product {
          id
          title
          description
          price
          media_url
        }
        user {
          avatar
          id
          name
          merchant {
            id
            business_name
            logo_url
            wait_time
          }
        }
      }
    }
    products: likes(
      where: { user_id: { _eq: $user_id }, product_id: { _is_null: false } }
      order_by: { created_at: desc }
    ) {
      id
      product {
        id
        media_url
        price
        description
        title
        limit_quantity
        user_id
        user {
          avatar
          id
          name
          merchant {
            id
            business_name
            logo_url
            wait_time
            location
          }
        }
      }
    }
  }
`;

export const POST_LIST = gql`
  {
    posts(order_by: { created_at: desc }) {
      id
    }
  }
`;

export const POST_INFO = gql`
  query($id: uuid!) {
    posts(where: { id: { _eq: $id } }) {
      id
      caption
      created_at
      url
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const PROMOTION_INFO = gql`
  query($id: uuid!) {
    promotions(where: { id: { _eq: $id } }) {
      id
      discount_percentage
      giveaway_percentage
      giveaway_purchases_count
      referral_percentage
      created_at
      product {
        title
        description
        price
        media_url
      }
      user {
        avatar
        id
        name
        merchant {
          id
          business_name
          logo_url
          wait_time
        }
      }
    }
  }
`;

export const GET_WITHDRAWAL = gql`
  query withdrawals($id: uuid!) {
    withdrawals_by_pk(id: $id) {
      amount
      fiat_amount
      timestamp
      id
      pay_req
    }
  }
`;

export const GET_WITHDRAWALS = gql`
  query withdrawals($user_id: String!) {
    withdrawals(
      where: { user_id: { _eq: $user_id } }
      order_by: { timestamp: desc }
    ) {
      amount
      fiat_amount
      timestamp
      id
      pay_req
    }
  }
`;

export const GET_WALLET_STATS = gql`
  query($user_id: String!) {
    withdrawal_sum: activities_aggregate(
      where: { actor_id: { _eq: $user_id }, type: { _eq: "withdrawal" } }
    ) {
      aggregate {
        sum {
          amount
        }
      }
    }
    spent_sum: activities_aggregate(
      where: { actor_id: { _eq: $user_id }, type: { _eq: "purchased" } }
    ) {
      aggregate {
        sum {
          fiat_amount
        }
      }
    }
    earn: activities_aggregate(
      where: {
        _or: [
          { actor_id: { _eq: $user_id }, type: { _eq: "cashback" } }
          { actor_id: { _eq: $user_id }, type: { _eq: "reward" } }
        ]
      }
    ) {
      aggregate {
        sum {
          amount
        }
      }
    }
  }
`;

export const GET_VERSION = gql`
  query versions {
    versions(where: {name: {_eq: "current"}}) {
      name
      version_number
    }
  }
`;

export const GET_BANNERS = gql`
  query banners($tab: String!) {
    banners(where: {tab: {_eq: $tab}}) {
      tab
      media_url
      title
      description
      position
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query notifications($cursor: timestamptz!, $limit: Int!) {
    notifications(
      limit: $limit,
      where: {
        created_at: { _lt: $cursor }
      }
      order_by: { created_at: desc }
    ) {
      id
      title
      message
      data
      type
      created_at
    }
  }
`;

export const GET_FAVORITES = gql`
query follows {
  follows (
    order_by: { created_at: desc }
  ) {
    follower_id
    merchant {
      id
      logo_url
      business_name
      location
      phone_number
      global_discount
      description
      address
      user_id
      category {
        id
        name
        icon
      }
      promotions_aggregate(where: {active: {_eq: true}, deleted_at: {_is_null: true}}) {
        aggregate {
          count
        }
      }
    }
  }
}
`;

export const GET_CATEGORIES = gql`
  query categories {
    categories {
      id
      name
      icon
    }
  }
`;


export const GET_MERCHANT_TRANSACTIONS = gql`
  query activities($actorid: String!, $cursor: timestamptz!, $limit: Int!) {
    activities_aggregate(
      where: {
        actor_id: { _eq: $actorid }
        type: { _eq: "merchant_revenue" }
      }
    ) {
      aggregate {
        sum {
          amount
          fiat_amount
        }
      }
    }
    activities(
      limit: $limit,
      where: { 
        actor_id: { _eq: $actorid } 
        type: { _eq: "merchant_revenue" }
        amount: { _gt: 0 }
        created_at: { _lt: $cursor }
      }
      order_by: { created_at: desc }
    ) {
      id
      amount
      fiat_amount
      type
      created_at
      purchase {
        id
        product {
          id
          title
          description
          price
          media_url
        }
        promotion {
          id
          product {
            id
            title
            description
            price
            media_url
          }
        }
      }
    }
  }
`;